export class RestoreImage201Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequest",
            "baseName": "mpaRequest",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "RestoreImage201ResponseMpaPolicies",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreImage201Response.attributeTypeMap;
    }
    constructor() {
    }
}
